import request from './request'

// 分类列表
export function categoryGetList(params) {
  return request({
    url: '/category/list',
    method: 'get',
    params
  })
}

// 分类新增
export function categoryCreate(data) {
  return request({
    url: '/category/create',
    method: 'post',
    data
  })
}

// 分类修改
export function categoryUpdate(id, data) {
  return request({
    url: '/category/update/' + id,
    method: 'put',
    data
  })
}

// 分类删除
export function categoryDelete(id) {
  return request({
    url: '/category/delete/' + id,
    method: 'delete'
  })
}


// 颜色列表
export function colorGetList(params) {
  return request({
    url: '/color/list',
    method: 'get',
    params
  })
}

// 颜色新增
export function colorCreate(data) {
  return request({
    url: '/color/create',
    method: 'post',
    data
  })
}

// 颜色编辑
export function colorUpdate(id, data) {
  return request({
    url: '/color/update/' + id,
    method: 'put',
    data
  })
}

// 颜色删除
export function colorDelete(id) {
  return request({
    url: '/color/delete/' + id,
    method: 'delete'
  })
}

// 尺码列表
export function sizeGetList(params) {
  return request({
    url: '/size/list',
    method: 'get',
    params
  })
}

// 模板列表
export function templateGetList(params) {
  return request({
    url: '/template/list',
    method: 'get',
    params
  })
}

// 上传图片
export function templateUploadImage(data, processCallback, cancelFun) {
  return request({
    url: '/template/uploadImage',
    method: 'post',
    data,
    onUploadProgress: processCallback
  })
}
// cancelToken已经是旧版方案，支持所有浏览器  AbortController更符合现代Web标准但不支持IE
// cancelToken 使用方法一
// import axios from 'axios';
// const source = axios.CancelToken.source();

// ,
// // 将 cancelToken 属性设置为上面创建的 CancelToken 实例
//     cancelToken: source.token

// 导出取消请求方法，在页面中引入使用
// export function axiosCancel() {
//   source.cancel('取消之前的请求');
// }

// 使用方法二
// import axios from 'axios';
// let cancelToken = axios.CancelToken;
// let cancel;

// ,
//    cancelToken: new cancelToken(function executor(c) {
//      // executor 函数接收一个 cancel 函数作为参数
//      cancel = c;
//    })

// export function axiosCancel() {
//   cancel();
// }

// 方法一跟方法二的区别：
// 方法一会永久取消这个请求跟之后所有相同的请求，就算后续再次调用请求还是会被取消
// 方法二只会取消操作的那次请求跟之前发送过的相同请求，如果后续再次调用不会被取消，除非再次触发取消

// 取消请求会触发catch，需通过axios.isCancel(error)或error.name === 'AbortError'判断是否为取消操作。
// 取消请求后，应清理存储的controller或cancel函数，避免内存泄漏。

// onDownloadProgress  下载进度

// 模板创建
export function templateCreate(data) {
  return request({
    url: '/template/create',
    method: 'post',
    data
  })
}

//模板详情
export function templateDetail(id) {
  return request({
    url: '/template/detail/' + id,
    method: 'get',
  })
}

//删除模板
export function templateDelete(id) {
  return request({
    url: '/template/delete/' + id,
    method: 'delete',
  })
}

//更新模板
export function templateUpdate(id, data) {
  return request({
    url: '/template/update/' + id,
    method: 'post',
    data
  })
}

// 分享模板
export function templateShare(data) {
  return request({
    url: '/template/shareToSubAccounts',
    method: 'post',
    data
  })
}

// 复制模板
export function templateCopy(id) {
  return request({
    url: '/template/duplicate/' + id,
    method: 'post'
  })
}

// 移动模板分类
export function templateRemoveCateg(id, data) {
  return request({
    url: '/template/updateCategory/' + id,
    method: 'post',
    data
  })
}

// 模板是否公开
export function templateUpdatePublic(data) {
  return request({
    url: '/template/update-public-status',
    method: 'post',
    data
  })
}

//创建抠图任务
export function cutout(image) {
  return request({
    url: '/tools/cutout',
    method: 'post',
    data: { image }
  })
}

//查询抠图结果
export function getSyncJob(task_id) {
  return request({
    url: '/tools/queryTask',
    method: 'get',
    params: { task_id }
  })
}

//上传mask图片
export function uploadImage(data) {
  return request({
    url: '/tools/uploadImage',
    method: 'post',
    data
  })
}

//创建图像分割任务
export function segment(imageUrl, maskImageUrl) {
  return request({
    url: '/tools/segment',
    method: 'post',
    data: { imageUrl, maskImageUrl }
  })
}